import { Languages } from '@wicadu/langscope'

import { type Page } from '@config/pages/const'
import { resolvePagePath } from './resolvePagePath'
import { type PagesId } from '@ts-enums/PagesId'

/**
 * Builds a URL based on the given pageId and language.
 *
 * This function finds the corresponding page object by the `pageId` and the `lang` (language),
 * then constructs the full URL using the `HELP_WEBAPP_HOST` environment variable and the `pathname` of the resolved page.
 *
 * @param pageId - The unique identifier of the page to find.
 * @param lang - The language to resolve the page in.
 * @returns A string representing the full URL of the page, or an empty string if the page cannot be found or an error occurs.
 */
export function getUrlByPageId(pageId: PagesId, lang: Languages): string {
  try {
    const host: string = process.env.HELP_WEBAPP_HOST
    const page: Page = resolvePagePath(pageId, lang)

    return `${host}${page?.pathname}`
  } catch {
    return ''
  }
}
